/**
 * UFD Custom JavaScript
 * Handles mobile menu toggle and other interactive elements
 */

document.addEventListener('DOMContentLoaded', function() {
  // Mobile Menu Toggle
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuIcon = document.getElementById('menu-icon');
  const closeIcon = document.getElementById('close-icon');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', function() {
      const isActive = mobileMenu.classList.toggle('active');
      
      // Toggle icons
      if (menuIcon && closeIcon) {
        if (isActive) {
          menuIcon.style.display = 'none';
          closeIcon.style.display = 'block';
        } else {
          menuIcon.style.display = 'block';
          closeIcon.style.display = 'none';
        }
      }
    });

    // Close menu when clicking on a link
    const mobileMenuLinks = mobileMenu.querySelectorAll('a');
    mobileMenuLinks.forEach(link => {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        if (menuIcon && closeIcon) {
          menuIcon.style.display = 'block';
          closeIcon.style.display = 'none';
        }
      });
    });
  }

  // Update cart count on cart changes
  document.addEventListener('cart:updated', function(event) {
    const cartCount = document.getElementById('cart-count');
    if (cartCount && event.detail && event.detail.cart) {
      cartCount.textContent = event.detail.cart.item_count;
    }
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#' && href.length > 1) {
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  // Add scroll-based navbar background
  let lastScroll = 0;
  const navbar = document.querySelector('.ufd-navbar');
  
  if (navbar) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 100) {
        navbar.style.backgroundColor = 'rgba(13, 13, 13, 0.95)';
      } else {
        navbar.style.backgroundColor = 'rgba(13, 13, 13, 0.9)';
      }
      
      lastScroll = currentScroll;
    });
  }

  // Simple fade-up animation on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  // Observe elements that should fade in
  const fadeElements = document.querySelectorAll('.ufd-product-card, .ufd-manifesto-item');
  fadeElements.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
});

// Newsletter form enhancement
document.addEventListener('DOMContentLoaded', function() {
  const newsletterForms = document.querySelectorAll('.ufd-newsletter-form');
  
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const button = this.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.textContent = 'SUBSCRIBING...';
      }
    });
  });
});

